module.exports = __webpack_public_path__ + "assets/cynergy_app_no_text.b4cb507c.svg";